import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ReplaceDataMatchupModalContainer,
  type ReplaceDataMatchupModalContainerProps,
} from './replaceDataMatchupModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ReplaceSpreadsheetDataMatchup: Omit<ReplaceDataMatchupModalContainerProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('ReplaceSpreadsheetDataMatchup', (props) => <ReplaceDataMatchupModalContainer {...props} />);
